import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Col, PopoverBody, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { LabelError } from '../Labels';
import InputDate from '../inputdate/InputDate';

import { Button } from '../Buttons';

import { PopoverWrapper } from './styles';

const FilterDateSelect = ({
  className,
  placement,
  target,
  showFilterDate,
  setShowFilterDate,
  // bothRequired,
  // inputRequired,
  fieldSelectedOption,
  column,
  onSearch,
}) => {
  const { t } = useTranslation();
  const { clearList } = useSelector((state) => state.notification);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });

  useEffect(() => {
    if (clearList) {
      reset({ dateFrom: '', dateTo: '' });
    }
  }, [clearList]);

  const onSubmit = (values) => {
    onSearch({
      ...values,
      fieldSelectedOption,
      column,
    });
  };

  const onClear = () => {
    reset({ dateFrom: '', dateTo: '' });
    onSearch({ dateFrom: '', dateTo: '', column });
  };

  return (
    <PopoverWrapper
      className={className}
      toggle={() => setShowFilterDate(!showFilterDate)}
      placement={placement}
      target={target}
      isOpen={showFilterDate}
    >
      <PopoverBody className="popover-body">
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
          <div className="form__form-group">
            <Controller
              name="dateFrom"
              control={control}
              defaultValue=""
              rules={{
                required: {
                  value: true,
                  message: t('general_required_field'),
                },
              }}
              render={({ field }) => (
                <InputDate
                  placeholder={t('general_filter_date_from')}
                  className="w-100"
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
            {errors.dateFrom && <LabelError label={errors.dateFrom.message} />}
          </div>

          <div className="form__form-group">
            <Controller
              name="dateTo"
              control={control}
              defaultValue=""
              rules={{
                required: {
                  value: true,
                  message: t('general_required_field'),
                },
              }}
              render={({ field }) => (
                <InputDate
                  placeholder={t('general_filter_date_to')}
                  className="w-100"
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
            {errors.dateTo && <LabelError label={errors.dateTo.message} />}
          </div>
          <Row className="w-100 remove-margin-horizontal">
            <Col sm={6} xs={6} className="remove-padding-horizontal">
              <Button
                className="text-uppercase"
                type="button"
                color="secondary"
                label={t('general_button_clean')}
                onClick={onClear}
              />
            </Col>
            <Col sm={6} xs={6} className="remove-padding-horizontal">
              <Button
                className="text-uppercase"
                type="submit"
                color="primary"
                label={t('general_button_filter')}
              />
            </Col>
          </Row>
        </form>
      </PopoverBody>
    </PopoverWrapper>
  );
};

FilterDateSelect.defaultProps = {
  className: '',
  // trigger: 'legacy',
  placement: 'bottom',
};

FilterDateSelect.propTypes = {
  className: PropTypes.string,
  // trigger: PropTypes.string,
  placement: PropTypes.string,
  target: PropTypes.string.isRequired,
  column: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  fieldSelectedOption: PropTypes.string.isRequired,
  showFilterDate: PropTypes.bool.isRequired,
  setShowFilterDate: PropTypes.func.isRequired,
};

export default FilterDateSelect;
